/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import type { RemoteNavigationView } from '@jira/polaris__component-navigation-store/src/TypesRemoteViewRemover.tsx';
import type { NavigationView } from '@jira/polaris__component-jpd-views-service/src/NavigationView.types.tsx';

const convertViewTypeFromRemote = (viewType: string): ViewKind => {
	switch (viewType) {
		case 'LIST':
			return 'TABLE';
		default:
			// oxlint-disable-next-line typescript/consistent-type-assertions
			return viewType as ViewKind;
	}
};

export const convertViewTypeToRemote = (
	viewType: ViewKind,
): 'LIST' | 'TIMELINE' | 'BOARD' | 'MATRIX' | 'SECTION' | 'TREE' => {
	switch (viewType) {
		case 'TABLE':
			return 'LIST';
		default:
			return viewType;
	}
};

export const transformView = (view: NavigationView): RemoteNavigationView => ({
	id: view.id,
	polarisId: view.polarisId,
	name: view.name,
	emoji: view.emoji,
	viewType: convertViewTypeFromRemote(view.viewType),
	views: view.views?.map((innerView: NavigationView) => ({
		id: innerView.id,
		polarisId: innerView.polarisId,
		name: innerView.name,
		emoji: innerView.emoji,
		viewType: convertViewTypeFromRemote(innerView.viewType),
	})),
});

export const transformViews = (views: NavigationView[]): RemoteNavigationView[] =>
	views.map(transformView);
